import fundacionBlanco from '../../assets/marca/fundacion-trauma-blanco.png';
import { SISTEMA } from '../../copy/index.js';

/**
 * "Un programa de" y el logo de Fundación Trauma, **sólo sobre el azul oscuro**
 * de las pantallas de acceso (P-01, todas las ramas).
 *
 * Provisorio: el archivo es un PNG de 250 x 79 con las letras blancas, el único
 * que hay hasta que llegue el SVG. Blanco, no se ve sobre fondo claro: en Perfil,
 * el pie del cuidador y el onboarding la firma sigue en texto. Se muestra a 125
 * px de ancho, la mitad de su tamaño real, para que se vea nítido en pantallas
 * de alta densidad. Cuando llegue el SVG se reemplaza el archivo y se amplía su
 * uso.
 */
export function FirmaDeFundacion() {
  return (
    <div className="flex flex-col items-center gap-2">
      <p className="m-0 text-base text-on-brand-subtle">{SISTEMA.marca.unProgramaDe}</p>
      <img
        alt={SISTEMA.marca.fundacion}
        className="h-auto max-w-full"
        height={40}
        src={fundacionBlanco}
        width={125}
      />
    </div>
  );
}
